__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/9b0dd24/_next/";